const dict: Record<string, string> = {
  // Nav
  dashboard: "Painel",
  catalog: "Catálogo",
  cart: "Carrinho",
  orders: "Pedidos",
  account: "Conta",
  invoices: "Faturas",
  nav_main: "Trabalho",
  nav_account: "Conta",

  // Common
  search: "Buscar",
  search_products: "Buscar por SKU, nome...",
  filter: "Filtro",
  sort: "Ordenar",
  add_to_cart: "Adicionar",
  in_cart: "No carrinho",
  place_order: "Fazer pedido",
  add_short: "Adicionar",
  add_more: "Adicionar mais",
  total: "Total",
  subtotal: "Subtotal",
  discount: "Desconto",
  delivery: "Entrega",
  qty: "Qtd",
  qty_decrement: "Diminuir quantidade",
  qty_increment: "Aumentar quantidade",
  logist_addr_derybasivska: "Derybasivska 12",
  logist_addr_tairova: "Tairova · Glushka 32",
  logist_addr_sklad: "Depósito · Promyslova 4",
  unit: "Por unidade",
  price: "Preço",
  retail: "Varejo",
  your_price: "Seu preço",
  saved: "Você economiza",
  sku: "SKU",
  stock: "Estoque",
  in_stock: "Em estoque",
  low_stock: "Pouco",
  out_of_stock: "Esgotado",
  create_order: "Criar pedido",
  repeat_order: "Repetir pedido",
  view_all: "Ver todos",
  items: "Itens",
  items_word: "itens",
  amount: "Valor",
  product: "Produto",
  status: "Status",
  payment: "Pagamento",
  paid: "Pago",
  unpaid: "Não pago",
  free: "Grátis",
  optional: "opcional",
  clear: "Limpar",
  retry: "Tentar novamente",
  repeat: "Repetir",
  invoice: "Fatura",
  order: "Pedido",
  date: "Data",
  due: "Vencimento",
  due_by: "até",
  primary: "Principal",
  primary_m: "Principal",
  yes: "Sim",
  no: "Não",
  all: "Todos",
  view: "Visualizar",
  admin: "Admin",
  user: "Usuário",
  invite: "Convidar",
  added: "Adicionado:",
  category: "Categoria",

  // Status
  status_new: "Novo",
  status_processing: "Em processo",
  status_shipped: "Enviado",
  status_delivered: "Entregue",
  status_cancelled: "Cancelado",

  // Login
  login_title: "Acesso ao portal B2B",
  login_sub: "Gerencie pedidos por atacado para o seu negócio.",
  email: "Email",
  password: "Senha",
  show_password: "Mostrar senha",
  hide_password: "Ocultar senha",
  forgot: "Esqueceu a senha?",
  sign_in: "Entrar",
  or: "ou",
  magic: "Enviar link de acesso",
  magic_link_send: "Enviar link mágico",
  magic_check_email: "Verifique seu e-mail",
  no_account: "Ainda não tem acesso?",
  request: "Solicitar conta",
  wholesale_portal: "Portal atacadista",
  signing_in: "Entrando...",
  invalid_email: "Email inválido",
  r_required_field: "Preencha os campos obrigatórios",
  r_submit_error: "Não foi possível enviar a solicitação. Tente novamente.",
  check_inbox: "Verifique sua caixa de entrada",
  magic_sent: "Enviamos um link de acesso para",
  magic_expire: "O link expira em 15 minutos.",
  back_to_password: "Voltar à senha",
  brand_panel_copy:
    "Peça grãos, equipamentos e acessórios direto da torrefação com preços negociados, pagamento NET-14 e gerente dedicado.",
  partner_venues: "estabelecimentos parceiros",
  on_market: "no mercado",
  payment_terms_label: "condições de pagamento",

  // Dashboard
  welcome: "Bem-vindo de volta",
  your_tier: "Seu plano",
  personal_manager: "Gerente dedicado",
  balance: "Saldo",
  recent_orders: "Pedidos recentes",
  quick_actions: "Ações rápidas",
  today_date_long: "18 DE ABRIL DE 2026 · SÁBADO",
  dash_sub_a: "Seu saldo, pedidos e ações rápidas para ",
  dash_sub_b: ".",
  credit: "Crédito",
  tier_b_hint: "Preços personalizados — 20% off do varejo",
  saved_this_year: "Economizado este ano",
  across_word: "em",
  orders_word: "pedidos",
  active_orders: "Pedidos ativos",
  one_processing: "1 em processo",
  send_message: "Enviar mensagem",
  whats_new: "Novidades",
  frequent_items: "Seus itens frequentes",
  one_click_reorder: "Repetir com um clique",

  // Catalog
  categories: "Categorias",
  availability: "Disponibilidade",
  origin: "Origem",
  weight: "Peso",
  cat_beans: "Grão",
  cat_ground: "Moído / drip",
  cat_equipment: "Equipamento",
  cat_accessories: "Acessórios",
  cat_training: "Treinamentos",
  view_grid: "Grade",
  view_table: "Tabela",
  wholesale_catalog: "Catálogo atacadista",
  catalog_sub_a: " SKUs · Preços refletem seu acordo HoReCa Tier B",
  any_availability: "Qualquer disponibilidade",
  featured: "Destaques",
  price_low_high: "Preço: menor → maior",
  price_high_low: "Preço: maior → menor",
  alpha: "A → Z",
  all_items: "Todos os produtos",
  catalog_err: "Não foi possível carregar o catálogo",
  catalog_err_sub: "Verifique sua conexão e tente novamente.",
  nothing_found: "Nada encontrado",
  nothing_found_sub: "Tente outras palavras-chave ou limpe os filtros.",
  clear_filters: "Limpar filtros",
  restocking: "Reabastecendo",

  // Cart
  your_cart: "Seu carrinho",
  empty_cart: "Carrinho vazio",
  empty_cart_sub: "Adicione produtos do catálogo para começar um pedido.",
  go_to_catalog: "Ir ao catálogo",
  order_summary: "Resumo do pedido",
  delivery_address: "Endereço de entrega",
  payment_method: "Forma de pagamento",
  payment_terms: "Pagamento NET-14",
  delivery_method: "Método de entrega",
  choose_one: "Escolha uma opção",
  odesa_logist: "Logística própria · Odesa",
  odesa_logist_meta: "1–2 dias úteis · dentro da cidade",
  odesa_logist_short: "Logística Odesa",
  np_short: "Nova Poshta",
  min_prefix: "mín.",
  available_from: "Disponível a partir de",
  shortfall_a: "Adicione mais ",
  shortfall_b: " para qualificar, ou escolha Nova Poshta abaixo.",
  add_items: "Adicionar itens",
  switch_to_np: "Trocar para Nova Poshta",
  np_switched_toast:
    "Entrega alterada para Nova Poshta: subtotal abaixo de 2 000 ₴",
  np_branch: "Nova Poshta · agência",
  np_meta: "1–3 dias úteis · nacional",
  city: "Cidade",
  branch_num: "Nº da agência",
  order_note: "Observação do pedido",
  order_note_ph: "Notas de entrega, etiquetagem, etc...",
  delivery_via_odesa: "Entrega · Logística Odesa",
  delivery_via_np: "Entrega · Nova Poshta",
  incl_vat: "Inclui IVA 20% ·",
  payment_status_unpaid: "Status de pagamento: Não pago",
  payment_status_unpaid_sub:
    "Pedido criado sem pagamento imediato. Seu gerente enviará uma fatura.",
  net14_note: "Sem pagamento imediato · NET-14",
  order_copied: "Pedido copiado para o carrinho",
  order_created_a: "Pedido criado ·",
  order_created_b: "· Não pago",
  order_error: "Não foi possível criar o pedido. Tente novamente.",

  // Orders
  order_history: "Histórico de pedidos",
  order_num: "Nº do pedido",
  ordered_on: "Data",
  orders_total_suffix: " pedidos no total · Clique para ver detalhes",
  search_by_num: "Buscar por número...",
  no_orders: "Nenhum pedido ainda",
  fulfilment: "Entrega",
  line_items: "Itens do pedido",
  unpaid_awaiting: "Não pago · aguardando fatura",
  payment_colon: "Pagamento:",
  download_invoice: "Baixar fatura",
  invoice_sent: "Fatura enviada para o seu e-mail",

  // Account
  company: "Empresa",
  addresses: "Endereços",
  payment_methods: "Pagamento",
  account_settings: "Conta e configurações",
  account_sub:
    "Gerencie sua empresa, endereços de entrega e métodos de pagamento.",
  team: "Equipe",
  preferences: "Preferências",
  company_details: "Dados da empresa",
  save_changes: "Salvar alterações",
  legal_name: "Razão social",
  brand_name: "Nome fantasia",
  tax_id: "CNPJ",
  vat_registered: "Contribuinte de IVA",
  billing_email: "Email de cobrança",
  phone: "Telefone",
  your_manager: "Seu gerente",
  payment_terms_row: "Condições de pagamento",
  customer_since: "Cliente desde",
  upgrade_tier:
    "Atualize para Tier A a partir de 500 000 UAH/ano — faltam 84 000 UAH.",
  credit_line: "Linha de crédito",
  available_word: "disponível",
  used: "Usado",
  limit: "Limite",
  delivery_addresses: "Endereços de entrega",
  add_address: "Adicionar endereço",
  payment_methods_title: "Métodos de pagamento",
  add_method: "Adicionar método",
  net14_apply:
    "As condições NET-14 aplicam-se automaticamente a pedidos acima de 5 000 UAH.",
  owner_role: "Proprietário",
  procurement: "Compras",
  head_barista: "Barista principal",
  team_members: "Membros da equipe",
  team_role: "Permissão",
  role_orders: "Pedidos",
  notifications: "Notificações",
  help: "Ajuda",
  menu: "Menu",
  search_placeholder: "Buscar tudo...",
  close: "Fechar",
  guest: "Visitante",
  logout: "Sair",
  remove: "Remover",
  notif_status: "Atualizações de status do pedido",
  notif_restock: "Alertas de reabastecimento",
  notif_new_arrivals: "Novidades do catálogo",
  notif_promo: "Promoções sazonais",

  // Invoices
  invoices_title: "Faturas e documentos",
  invoices_sub: "Notas fiscais, comprovantes de entrega e recibos.",
  export_csv: "Exportar CSV",

  // Not found
  not_found_title: "Página não encontrada",
  not_found_subtitle: "O link pode estar desatualizado ou a página foi movida.",
  go_to_dashboard: "Ir para o painel",

  // Misc
  today: "hoje",
  yesterday: "ontem",
  days_ago: "d atrás",

  // Register
  r_eyebrow: "Portal atacadista · Inscrição",
  r_title: "Solicitar uma conta",
  r_sub:
    "Conte-nos sobre seu negócio — seu gerente preparará uma proposta personalizada em 1 dia útil.",
  r_s1: "Empresa",
  r_s2: "Estabelecimento",
  r_s3: "Contato",
  r_step: "Passo",
  r_of: "de",
  r_company_legal: "Razão social",
  r_company_hint: "LTDA / MEI",
  r_edrpou: "CNPJ",
  r_vat: "Contribuinte de IVA",
  r_yes: "Sim",
  r_no: "Não",
  r_brand_name: "Nome do estabelecimento (marca)",
  r_brand_hint: "Nome público visto pelos clientes",
  r_venue_type: "Tipo de estabelecimento",
  r_cafe: "Café",
  r_restaurant: "Restaurante",
  r_hotel: "Hotel",
  r_office: "Escritório / corporativo",
  r_reseller: "Revendedor",
  r_other: "Outro",
  r_venues: "Número de unidades",
  r_volume: "Consumo mensal estimado de café",
  r_v1: "Até 20 kg",
  r_v2: "20–50 kg",
  r_v3: "50–150 kg",
  r_v4: "Mais de 150 kg",
  r_name_full: "Nome completo do contato",
  r_role: "Sua função",
  r_owner: "Proprietário",
  r_buyer: "Comprador",
  r_barista: "Barista principal",
  r_manager: "Gerente",
  r_email: "Email comercial",
  r_phone: "Telefone",
  r_note: "Observação para o gerente",
  r_note_ph:
    "O que você está comprando, marcas preferidas, necessidades especiais...",
  r_accept_tos: "Concordo com os termos de cooperação e tratamento de dados",
  r_accept_tos_required: "É necessário aceitar os termos",
  r_continue: "Continuar",
  r_back: "Voltar",
  r_submit: "Enviar solicitação",
  r_have_account: "Já tem acesso?",
  r_sign_in: "Entrar",
  r_sent_title: "Solicitação recebida!",
  r_sent_sub:
    "Anna Lytvyn, sua futura gerente, entrará em contato em até 24 horas pelo número",
  r_what_next: "O que acontece a seguir",
  r_n1: "Seu gerente verificará os dados e definirá preços HoReCa personalizados",
  r_n2: "Você receberá um email com login e senha temporária",
  r_n3: "Primeiro pedido — com desconto de −5% no total",
  r_back_to_site: "Voltar para foundation.ua",
  r_why_title: "Por que ser parceiro Foundation B2B",
  r_w1_t: "Preços personalizados",
  r_w1_s: "Faixas HoReCa de −15% a −25% do varejo",
  r_w2_t: "Pagamento NET-14",
  r_w2_s: "Faturamento diferido para parceiros estabelecidos",
  r_w3_t: "Gerente pessoal",
  r_w3_s: "Linha direta, sem fila de tickets",
  r_w4_t: "Entrega prioritária",
  r_w4_s: "No dia seguinte em Odesa, 2 dias nacionalmente",
  r_for_venues: "Para estabelecimentos e revendedores",
  r_hero_a: "Torne-se um",
  r_hero_b: "parceiro",
  r_hero_c: "Foundation.",
  r_bottom_copy:
    "Mais de 240 estabelecimentos na Ucrânia compram grãos, equipamentos e acessórios direto da nossa torrefação em Odesa.",
};

export default dict;
